import { createElement, Component } from 'react';
import { object, bool, func } from 'prop-types';
import { e as _inheritsLoose, f as _defineProperty, g as _assertThisInitialized, b as _objectWithoutPropertiesLoose, c as _extends } from '../chunk-ad6ad343.js';
import Box from 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import { withMenuContext } from './MenuContext.js';
var KEYS = {
  UP: 38,
  DOWN: 40,
  TAB: 9,
  SPACE: 32
};
var menuTriggerPropTypes = {
  context: object,
  isVisible: bool,
  onClick: func
};
var menuTriggerDefaultProps = {
  context: undefined,
  isVisible: false,
  onClick: undefined
};

var MenuTrigger = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(MenuTrigger, _React$Component);

  function MenuTrigger() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (e) {
      var _this$props = _this.props,
          context = _this$props.context,
          isVisible = _this$props.isVisible;

      if (!isVisible) {
        if (e.keyCode === KEYS.DOWN || e.keyCode === KEYS.TAB || e.keyCode === KEYS.SPACE || e.keyCode === KEYS.UP) {
          e.preventDefault();
          context && context.handleMenuOpenViaKeyboard({
            startAt: e.keyCode === KEYS.UP ? 'last' : 'first'
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var _this$props2 = _this.props,
          context = _this$props2.context,
          props = _objectWithoutPropertiesLoose(_this$props2, ["context"]);

      return createElement(Box, _extends({
        "aria-haspopup": "menu",
        "aria-expanded": context && context.isVisible,
        onKeyDown: _this.handleKeyDown
      }, context, props, {
        type: "button"
      }));
    });

    return _this;
  }

  return MenuTrigger;
}(Component); // @ts-ignore


_defineProperty(MenuTrigger, "propTypes", menuTriggerPropTypes);

_defineProperty(MenuTrigger, "defaultProps", menuTriggerDefaultProps);

var C = withMenuContext(MenuTrigger);
export default C;
export { MenuTrigger, menuTriggerDefaultProps, menuTriggerPropTypes };